module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm3": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¡Felicitaciones, ha creado su presupuesto!",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¡Felicitaciones,"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("ha creado ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" su presupuesto!")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¡Felicitaciones, ha creado su presupuesto!',
      "videoEmbed": "ADMINISTRACIONDINERO38FelicitacionesSuPresupuesto.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "text-xs-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeIn dura_3",
    attrs: {
      "xs12": "",
      "sm1": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated flash",
    attrs: {
      "imaSize": 80,
      "imaSrc": "design/banco3-1-1",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInDown dura_2",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": "",
      "mb-5": ""
    }
  }, [_c('p', [_vm._v("\n        Por favor\n        "), _c('strong', [_vm._v("guárdelo, imprímalo")]), _vm._v(" y cuente con este para manejar su presupuesto.\n      ")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "animated tada infinite",
    on: {
      "click": function($event) {
        _vm.printData()
      }
    }
  }, [_c('image-app', {
    staticClass: "hvr-grow",
    attrs: {
      "imaSize": 170,
      "imaSrc": "contenido/diapositiva_39",
      "imaAlt": "Guardar datos de presupuesto en PDF"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "1200",
      "height": "800"
    },
    model: {
      value: (_vm.formDialog),
      callback: function($$v) {
        _vm.formDialog = $$v
      },
      expression: "formDialog"
    }
  }, [_c('div', {
    attrs: {
      "id": "form-print"
    }
  }, [_c('ui-calculadora-print')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593fde80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-38.vue
// module id = 1009
// module chunks = 1